// extracted by mini-css-extract-plugin
export var equalColumn = "_f5-0";